import React, { memo } from 'react';
import { Text } from '@beef/ui-kit';
import { Title } from "../../../Title";
export var TextInfo = /*#__PURE__*/memo(function (_ref) {
  var headerText = _ref.headerText,
    subtitleText = _ref.subtitleText,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-TextInfo"
  }, headerText && /*#__PURE__*/React.createElement(Title, {
    isWithSubtitle: !!subtitleText
  }, headerText), subtitleText && /*#__PURE__*/React.createElement(Text, {
    color: "textIconElementSecondary",
    size: "size4-r"
  }, subtitleText));
});